"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const __1 = require("..");
const TextLink = (0, react_1.forwardRef)(({ children, className, external = false, href, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)(__1.Link, { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-link', external && 'usa-link--external', className), external: external, href: href, ...props, children: children }));
});
exports.default = TextLink;
